export default class UamfHttpError extends Error {
    readonly status: number;
    readonly body: unknown;

    constructor(status: number, statusText: string, body: unknown) {
        super(`HTTP ${status} ${statusText}`);
        this.name = 'UamfHttpError';
        this.status = status;
        this.body = body;
    }
}
